<template>
	<div
		class="theme-sheet"
		:class="{ 'is-pc': isPc }"
		v-show="visible"
		@click.stop="close"
	>
		<div class="sheet-panel" @click.stop>
			<div class="sheet-handle" v-if="!isPc" aria-hidden="true"></div>
			<div class="sheet-title">{{ $t('lendingTheme.title') }}</div>
			<div class="theme-list">
				<div
					class="theme-item"
					v-for="item in options"
					:key="item.value"
					:class="{ active: themeMode === item.value }"
					@click="select(item.value)"
				>
					<span class="theme-name">{{ $t(item.labelKey) }}</span>
					<svg
						v-if="themeMode === item.value"
						class="theme-check"
						width="18"
						height="18"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M4.5 10.5L8.2 14.2L15.5 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</div>
			</div>
			<div class="sheet-cancel" @click="close">{{ $t('account.cancel') }}</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'ThemeSheet',
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			options: [
				{ value: 'auto', labelKey: 'lendingTheme.auto' },
				{ value: 'light', labelKey: 'lendingTheme.light' },
				{ value: 'dark', labelKey: 'lendingTheme.dark' }
			]
		}
	},
	computed: {
		...mapState(['isPc', 'themeMode'])
	},
	methods: {
		close() {
			this.$emit('close')
		},
		select(mode) {
			this.$store.commit('SET_THEME_MODE', mode)
			this.close()
		}
	}
}
</script>

<style lang="scss" scoped>
.theme-sheet {
	position: fixed;
	inset: 0;
	z-index: 100;
	background: var(--ld-overlay, rgba(17, 17, 17, 0.36));
	display: flex;
	align-items: flex-end;
	justify-content: center;
	box-sizing: border-box;
}

.theme-sheet.is-pc {
	align-items: center;
	padding: 24px;
}

.sheet-panel {
	width: 100%;
	max-width: 520px;
	background: var(--ld-bg-card, #fff);
	color: var(--ld-text, #111);
	border-radius: 0.2rem 0.2rem 0 0;
	padding: 0.1rem 0.16rem calc(0.16rem + var(--ld-safe-bottom));
	box-sizing: border-box;
	animation: theme-sheet-up 0.22s ease-out;
}

.theme-sheet.is-pc .sheet-panel {
	width: 400px;
	max-width: 92vw;
	border-radius: 16px;
	padding: 20px 16px 16px;
	animation: theme-center-in 0.2s ease-out;
	box-shadow: var(--ld-shadow);
}

.sheet-handle {
	width: 0.36rem;
	height: 0.04rem;
	border-radius: 999px;
	background: var(--ld-handle, #d8d8d8);
	margin: 0.06rem auto 0.12rem;
}

.sheet-title {
	font-size: 0.16rem;
	font-weight: 600;
	text-align: center;
	padding: 0.04rem 0.12rem 0.14rem;
}

.theme-sheet.is-pc .sheet-title {
	font-size: 18px;
}

.theme-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 0.48rem;
	padding: 0.12rem 0.14rem;
	border-radius: 0.12rem;
	font-size: 0.16rem;
	cursor: pointer;
	user-select: none;

	&.active {
		background: var(--ld-bg-active, #f2f2f2);
		font-weight: 600;
	}

	&:active {
		background: var(--ld-bg-active, #f2f2f2) !important;
		border-radius: 0.12rem !important;
	}
}

.theme-sheet.is-pc .theme-item {
	min-height: 44px;
	font-size: 15px;
	border-radius: 10px;
}

.theme-check {
	color: var(--ld-text, #111);
}

.sheet-cancel {
	margin-top: 0.1rem;
	min-height: 0.48rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.12rem;
	background: var(--ld-bg-muted, #f5f5f5);
	color: var(--ld-text, #333);
	font-size: 0.15rem;
	font-weight: 500;
	cursor: pointer;
}

.theme-sheet.is-pc .sheet-cancel {
	min-height: 44px;
	font-size: 14px;
	margin-top: 12px;
}

.sheet-cancel:active {
	background: var(--ld-bg-active, #ececec) !important;
	border-radius: 0.12rem !important;
}

@keyframes theme-sheet-up {
	from { transform: translateY(100%); }
	to { transform: translateY(0); }
}

@keyframes theme-center-in {
	from {
		opacity: 0;
		transform: scale(0.96) translateY(8px);
	}
	to {
		opacity: 1;
		transform: scale(1) translateY(0);
	}
}
</style>
